class SiteHeader extends HTMLElement { // eslint-disable-line
  constructor() {
    super()
  }

  connectedCallback() {
    this.setBottomOfHeader()
    window.addEventListener('resize', () => { this.setBottomOfHeader() })
    document.addEventListener('rebuy.loaded', () => { this.setBottomOfHeader() })
  }

  setBottomOfHeader () {
    const bottomOfHeaderGroup = this.getBoundingClientRect().bottom
    document.body.style.setProperty('--bottom-of-site-header', `${bottomOfHeaderGroup}px`)

    const header = this.querySelector('header')
    const slidingNav = this.querySelector('.sliding-nav')
    if (!header) { return }

    const bottomOfNav = window.getComputedStyle(slidingNav)?.display === 'none' ? header.getBoundingClientRect().bottom : slidingNav.getBoundingClientRect().bottom
    document.body.style.setProperty('--bottom-of-nav', `${bottomOfNav}px`)
  }
}

if (typeof window.customElements.get('site-header') === 'undefined') {
  window.customElements.define('site-header', SiteHeader)
}

class MobileNavToggle extends HTMLElement {
  constructor() {
    super();
    this.toggleButton = this.querySelector('[data-mobile-nav-toggle]');
    this.toggleButton.addEventListener('click', this.toggleNav.bind(this));
    this.section = this.closest('.navigation-section')
  }

  toggleNav(event) {
    const mobileNav = document.querySelector('mobile-nav');

    if (event.target.hasAttribute('data-mobile-nav-screenreader-close')) {
      const mobileNavToggles = document.querySelectorAll('mobile-nav-toggle');

      scrollLock.unlock();
      document.body.classList.remove('nav-open');
      mobileNav.classList.remove('active');

      mobileNavToggles.forEach((mobileNavToggle, index) => {
        if (index === 0) {
          mobileNavToggle.querySelector('[data-mobile-nav-toggle]').focus();
        }

        mobileNavToggle.classList.remove('active');
      });
    } else {
      mobileNav.classList.toggle('active');
      this.classList.toggle('active');

      if (this.classList.contains('active')) {
        scrollLock.lock()
        document.body.classList.add('nav-open');
      } else {
        scrollLock.unlock();
        document.body.classList.remove('nav-open');
      }
    }
  }
}

if (typeof window.customElements.get('mobile-nav-toggle') === 'undefined') {
  customElements.define('mobile-nav-toggle', MobileNavToggle);
}

class MobileNav extends HTMLElement {
  constructor() {
    super();
    this.submenuToggleButtons = this.querySelectorAll('[data-mobile-nav-submenu-toggle]');
    this.submenuLinkWrappers = this.querySelectorAll('[data-mobile-nav-submenu-link-wrapper]');
    this.backButtons = this.querySelectorAll('[data-mobile-nav-back]');
    this.submenuToggleButtons.forEach((submenuToggleButton) => submenuToggleButton.addEventListener('click', this.openSubmenu.bind(this)));
    this.backButtons.forEach((backButton) => backButton.addEventListener('click', this.goBack.bind(this)));
  }

  openSubmenu(event) {
    const linkWrapper = event.currentTarget.closest('[data-mobile-nav-submenu-link-wrapper]');
    linkWrapper.classList.add('submenu-active');
    this.classList.add('submenu-active');
    trapFocus(linkWrapper);
  }

  goBack() {
    this.submenuLinkWrappers.forEach((submenuLinkWrapper) => submenuLinkWrapper.classList.remove('submenu-active'));
    this.classList.remove('submenu-active');
    removeTrapFocus();
  }
}

if (typeof window.customElements.get('mobile-nav') === 'undefined') {
  customElements.define('mobile-nav', MobileNav);
}
